import React, { useState } from 'react';

const MAX_LENGTH = 500;

interface LessonCommentEditorProps {
  initialContent: string;
  saving: boolean;
  onSave: (content: string) => void;
  onCancel: () => void;
}

const LessonCommentEditor: React.FC<LessonCommentEditorProps> = ({
  initialContent,
  saving,
  onSave,
  onCancel,
}) => {
  const [content, setContent] = useState(initialContent);

  return (
    <div className="mt-1">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        disabled={saving}
        maxLength={MAX_LENGTH}
        rows={3}
        className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-terracota disabled:opacity-50 disabled:cursor-not-allowed"
      />
      <div className="flex items-center gap-2 mt-2">
        <button
          onClick={() => onSave(content.trim())}
          disabled={saving || !content.trim()}
          className={`px-3 py-1.5 text-xs rounded-lg bg-terracota text-white hover:bg-red-700 transition ${
            saving || !content.trim() ? 'cursor-not-allowed opacity-50' : ''
          }`}
        >
          {saving ? 'Salvando...' : 'Salvar'}
        </button>
        <button
          onClick={onCancel}
          disabled={saving}
          className={`px-3 py-1.5 text-xs rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition ${
            saving ? 'cursor-not-allowed opacity-50' : ''
          }`}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default LessonCommentEditor;
